import script from "./LoginL.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginL.vue?vue&type=script&setup=true&lang=js"

import "./LoginL.vue?vue&type=style&index=0&id=7b883a3c&lang=less"

const __exports__ = script;

export default __exports__